// extracted by mini-css-extract-plugin
export var falconContainer = "_vr-2";
export var offerCenter = "_vr-0";
export var roktContainer = "_vr-1";